export const isPermissionAllow = (permission, role) => {
  if (role === '1') {
    return true;
  } else {
    return permission;
  }
};
